/** Mirror Lucide left/right arrows in RTL (e.g. Persian) so “next” / “prev” match reading direction. */
export function localeMirroredNavArrowClass(isRtl: boolean, sizeClass = ''): string {
  return [sizeClass, isRtl ? 'rotate-180' : ''].filter(Boolean).join(' ');
}
